<template>

    <div class="introDetail px-360 admission" style="position: relative; margin-top: -200px;">
        <BannerStatic :ban="wWidth < 768 ? banner[1] : banner[0]" style="height: 100%; "></BannerStatic>
        <div class="na"
            style="position: relative; margin-top: -6.77vw; width: 100%; background-color: #dee8f7; opacity: 0.8; padding: 10px 0;">
            <div class="nav">
                <!-- 标题区域 - 与左侧内容对齐 -->
                <div class="title-wrapper">
                    <YYTitle :yyMsg="yyMessage" class="hidden-xs-only"></YYTitle>
                    <XSTitle :main="yyMessage" :sub="titEN" class="hidden-sm-and-up"></XSTitle>
                </div>

                <!-- 主要内容区域 -->
                <div class="content-wrapper">
                    <el-row type="flex" :gutter="50" justify="center" align="middle">
                        <!-- 左侧文字 -->
                        <el-col :xs="24" :sm="24" :md="16" :lg="16">
                            <div class="intro">
                                <div class="tech-header">
                                    <span class="line"></span>
                                    <span class="dot"></span>
                                    <span class="line right"></span>
                                </div>

                                <p v-for="(item, index) in p" :key="index"
                                    :style="{ animationDelay: (index * 0.15) + 's' }">
                                    {{ item }}
                                </p>

                            </div>
                        </el-col>

                        <!-- 右侧Logo -->
                        <el-col :xs="24" :sm="24" :md="8" :lg="8">
                            <div class="logo-wrapper">
                                <div class="imgLimit">
                                    <div class="halo"></div>
                                    <div class="halo ring-2"></div>
                                    <div class="halo ring-3"></div>
                                    <div class="halo ring-4"></div>
                                    <div class="glow-bg"></div>
                                    <img :src="require('@/assets/logoAb2.png')" alt="医影智能科技" loading="lazy">
                                    <div class="brand-tag">
                                        <span>医影</span>
                                        <span class="divider">|</span>
                                        <span>智能</span>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import YYTitle from '../yyTitle.vue'
import XSTitle from '../eyTitXs.vue'
import BannerStatic from '@/components/header/bannerStatic.vue'

export default {
    components: {
        YYTitle,
        XSTitle,
        BannerStatic
    },
    data() {
        return {
            banner: [require('@/assets/employ/logo1.1.png'), require('@/assets/phone/bannerAb.png')],
            wWidth: window.screen.width,
            yyMessage: '公司介绍',
            titEN: 'COMPANY INTRODUCTION',
            p: ["山东医影智能科技有限公司专注于“互联网+医学影像”技术的研发，拥有强大的技术核心团队，自主研发医学影像虚拟仿真系统、影像云平台、医学图像处理教学系统等产品，现已申请多项软件著作权。公司主要服务于具有医学影像技术、医学影像学、生物医学工程等相关专业的院校等及有相关培训需求的医院、企业。",
                "公司拥有强大的技术核心团队，从业人员在医学影像领域有多年教学及临床经验，拥有国家级专家顾问3人，其中有多名中华医学会影像技术分会委员，同时公司积极响应国家千名博士进企业行动，引进博士人才入公司带队进行项目开发。",
                "公司自主研发的医学影像虚拟仿真类软件，获得了教育部及山东省教育厅、烟台市政府的认可，成为烟台市校地融合重点资助项目、山东省教育厅虚拟仿真重点研究课题及入围国家级虚拟仿真实验教学项目评审。虚拟仿真系列软件在国内市场处于领先水平，研发团队通过不断努力和完善，正逐步结合临床应用，服务于更为广泛的大众市场。"]
        }
    }
}
</script>

<style lang="scss" scoped>
.introDetail {
    position: relative;
    overflow: hidden;
    padding: vw(20) 0 vw(40);
    top: 50%;

    // 科技感背景
    background:
        linear-gradient(rgba(59, 130, 246, 0.04) 1px, transparent 1px),
        linear-gradient(90deg, rgba(59, 130, 246, 0.04) 1px, transparent 1px),
        radial-gradient(ellipse at 40% 50%, #f0f4ff 0%, #e4ebf7 50%, #d5dfee 100%);
    background-size: 40px 40px, 40px 40px, 100% 100%;

    // 光晕装饰
    &::before {
        content: '';
        position: absolute;
        top: -200px;
        right: -100px;
        width: 500px;
        height: 500px;
        background: radial-gradient(circle, rgba(59, 130, 246, 0.08) 0%, transparent 70%);
        border-radius: 50%;
        pointer-events: none;
        animation: floatGlow 8s ease-in-out infinite;
    }

    &::after {
        content: '';
        position: absolute;
        bottom: -150px;
        left: -80px;
        width: 400px;
        height: 400px;
        background: radial-gradient(circle, rgba(30, 58, 138, 0.06) 0%, transparent 70%);
        border-radius: 50%;
        pointer-events: none;
        animation: floatGlow 10s ease-in-out infinite reverse;
    }

    .nav {
        width: 80%;
        margin: auto;
    }

    // 标题容器 - 与左侧内容对齐
    .title-wrapper {
        max-width: 1400px;
        margin: 0 auto;
        padding: 0 vw(20);

        // 让标题与左侧内容对齐（对应16列中的左侧）
        ::v-deep {
            .cusTitle {
                margin-left: 0;
                padding-left: 0;
            }
        }
    }

    .content-wrapper {
        max-width: 1400px;
        margin: 0 auto;
        padding: 0 vw(20);
    }

    .intro {
        position: relative;
        padding: vw(44) vw(48);
        margin: vw(20) 0;
        background: rgba(255, 255, 255, 0.75);
        backdrop-filter: blur(20px);
        -webkit-backdrop-filter: blur(20px);
        border: 1px solid rgba(59, 130, 246, 0.12);
        border-radius: 20px;
        box-shadow:
            0 8px 40px rgba(30, 58, 138, 0.06),
            0 2px 12px rgba(59, 130, 246, 0.06),
            inset 0 1px 0 rgba(255, 255, 255, 0.9);
        transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);

        &:hover {
            box-shadow:
                0 16px 56px rgba(30, 58, 138, 0.1),
                0 4px 20px rgba(59, 130, 246, 0.08),
                inset 0 1px 0 rgba(255, 255, 255, 0.9);
            border-color: rgba(59, 130, 246, 0.25);
            transform: translateY(-2px);
        }

        .tech-header {
            display: flex;
            align-items: center;
            gap: 12px;
            margin-bottom: vw(28);
            opacity: 0.5;

            .line {
                flex: 1;
                height: 2px;
                background: linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.3));
                border-radius: 2px;

                &.right {
                    background: linear-gradient(90deg, rgba(59, 130, 246, 0.3), transparent);
                }
            }

            .dot {
                width: 8px;
                height: 8px;
                background: #3b82f6;
                border-radius: 50%;
                box-shadow: 0 0 24px rgba(59, 130, 246, 0.4);
                animation: pulseDot 2s ease-in-out infinite;
                flex-shrink: 0;
            }
        }

        p {
            position: relative;
            font-size: vw(18);
            text-align: left;
            text-indent: 2em;
            line-height: 2.4;
            color: #1a2a4a;
            margin-bottom: vw(20);
            padding: 0 vw(4);
            opacity: 0;
            animation: fadeUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;

            &:last-child {
                margin-bottom: 0;
            }

            &::before {
                content: '';
                position: absolute;
                left: -4px;
                top: 15%;
                height: 70%;
                width: 3px;
                background: linear-gradient(180deg, #3b82f6, #1e3a8a, #3b82f6);
                border-radius: 2px;
                opacity: 0.12;
                transition: opacity 0.3s ease;
            }

            &:hover::before {
                opacity: 0.35;
            }
        }

    }

    // ========== Logo区域 ==========
    .logo-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        padding: vw(20) 0;
    }

    .imgLimit {
        position: relative;
        width: 100%;
        max-width: vw(420);
        aspect-ratio: 1 / 1.05;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .glow-bg {
            position: absolute;
            width: 85%;
            height: 85%;
            top: 7.5%;
            left: 7.5%;
            background: radial-gradient(circle at center, rgba(59, 130, 246, 0.1) 0%, transparent 70%);
            border-radius: 50%;
            z-index: 0;
            animation: pulseGlow 4s ease-in-out infinite;
        }

        &::before {
            content: '';
            position: absolute;
            inset: -4px;
            background: conic-gradient(from 0deg,
                    transparent 0%,
                    #3b82f6 15%,
                    #1e3a8a 35%,
                    #3b82f6 55%,
                    #1e3a8a 75%,
                    transparent 100%);
            border-radius: 24px;
            z-index: -1;
            animation: rotateBorder 8s linear infinite;
            opacity: 0.4;
            filter: blur(8px);
        }

        &::after {
            content: '';
            position: absolute;
            inset: 0;
            background: rgba(255, 255, 255, 0.55);
            backdrop-filter: blur(16px);
            -webkit-backdrop-filter: blur(16px);
            border: 1px solid rgba(59, 130, 246, 0.12);
            border-radius: 20px;
            z-index: -1;
            box-shadow:
                inset 0 0 60px rgba(59, 130, 246, 0.03),
                0 8px 32px rgba(30, 58, 138, 0.08);
        }

        &:hover::before {
            opacity: 0.6;
        }

        .halo {
            position: absolute;
            border-radius: 50%;
            pointer-events: none;
            z-index: 1;

            &:nth-child(1) {
                width: 108%;
                height: 108%;
                top: -4%;
                left: -4%;
                border: 1.5px solid rgba(59, 130, 246, 0.1);
                animation: spin 12s linear infinite;
            }

            &.ring-2 {
                width: 126%;
                height: 126%;
                top: -13%;
                left: -13%;
                border: 1px solid rgba(59, 130, 246, 0.07);
                animation: spin 18s linear infinite reverse;
            }

            &.ring-3 {
                width: 144%;
                height: 144%;
                top: -22%;
                left: -22%;
                border: 1px dashed rgba(59, 130, 246, 0.05);
                animation: spin 24s linear infinite;
            }

            &.ring-4 {
                width: 162%;
                height: 162%;
                top: -31%;
                left: -31%;
                border: 1px solid rgba(59, 130, 246, 0.04);
                animation: spin 30s linear infinite reverse;
            }
        }

        img {
            width: 65%;
            height: 65%;
            object-fit: contain;
            position: relative;
            z-index: 2;
            filter: drop-shadow(0 4px 24px rgba(59, 130, 246, 0.2));
            animation: floatImg 5s ease-in-out infinite;
            transition: filter 0.4s ease, transform 0.4s ease;

            &:hover {
                filter: drop-shadow(0 8px 40px rgba(59, 130, 246, 0.35));
                transform: scale(1.03);
            }
        }

        .brand-tag {
            position: absolute;
            bottom: 7%;
            z-index: 3;
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 8px 24px;
            background: rgba(255, 255, 255, 0.9);
            backdrop-filter: blur(8px);
            border: 1px solid rgba(59, 130, 246, 0.15);
            border-radius: 30px;
            font-size: vw(16);
            font-weight: 600;
            color: #1e3a8a;
            letter-spacing: 1.5px;
            opacity: 0;
            animation: fadeUp 0.8s ease 0.6s forwards;
            box-shadow: 0 4px 16px rgba(59, 130, 246, 0.1);

            .divider {
                color: rgba(59, 130, 246, 0.25);
                font-weight: 300;
            }
        }
    }

    // ========== 标题样式重写 - 与左侧对齐 ==========
    ::v-deep {
        .cusTitle {
            position: relative;
            font-size: vw(30);
            margin: 0;
            margin-top: vw(78);
            margin-bottom: vw(10);
            text-align: left;
            font-weight: 700;
            background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 60%, #60a5fa 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            letter-spacing: 2px;
            // 确保与左侧内容对齐
            padding-left: 0;
            width: 100%;

            &:after {
                content: 'COMPANY INTRODUCTION';
                top: vw(-55);
                font-weight: 900;
                color: rgba(138, 91, 30, 0.5);
                letter-spacing: 3px;
                -webkit-text-fill-color: rgba(30, 58, 138, 0.5);
                left: 0;
            }

            &::before {
                content: '';
                position: absolute;
                left: 0;
                bottom: -8px;
                width: 60px;
                height: 3px;
                background: linear-gradient(90deg, #3b82f6, #1e3a8a);
                border-radius: 2px;
                animation: shimmer 2s ease-in-out infinite;
                background-size: 200% 100%;
            }
        }
    }


    // ========== 响应式 ==========

    @media only screen and (max-width: 767px) {
        background-size: 25px 25px, 25px 25px, 100% 100%;
        padding: 0 0 vp(40);

        .title-wrapper {
            padding: 0 vp(16);
        }

        .content-wrapper {
            padding: 0 vp(16);
        }

        .intro {
            padding: vp(32) vp(20) vp(36);
            margin: 0 0 vp(30);
            border-radius: 16px;

            .tech-header {
                margin-bottom: vp(24);

                .dot {
                    width: 6px;
                    height: 6px;
                }
            }


            p {
                font-size: vp(30);
                line-height: 1.8;
                text-indent: 2em;
                padding: 0 vp(4);
                margin-bottom: vp(24);

                &::before {
                    left: -2px;
                    width: 2px;
                }
            }
        }

        .logo-wrapper {
            padding: 0;
        }

        .imgLimit {
            max-width: vp(320);
            aspect-ratio: 1 / 1;

            .halo {
                &:nth-child(1) {
                    width: 106%;
                    height: 106%;
                    top: -3%;
                    left: -3%;
                }

                &.ring-2 {
                    width: 120%;
                    height: 120%;
                    top: -10%;
                    left: -10%;
                }

                &.ring-3 {
                    display: none;
                }

                &.ring-4 {
                    display: none;
                }
            }

            .glow-bg {
                display: none;
            }

            img {
                width: 60%;
                height: 60%;
            }

            .brand-tag {
                bottom: 8%;
                padding: 5px 16px;
                font-size: vp(18);
                gap: 8px;
            }
        }

        ::v-deep {
            .eyTit {
                margin-top: vp(50);
                text-align: left !important;
            }

            .cusTitle {
                margin-top: vp(50) !important;
                font-size: vp(36) !important;
            }
        }
    }

    // 平板适配
    @media only screen and (min-width: 768px) and (max-width: 1024px) {
        .intro {
            padding: vw(32) vw(36) !important;

            p {
                font-size: vw(16) !important;
            }
        }

        .imgLimit {
            max-width: vw(320) !important;
        }
    }
}

// ==================== 动画 ====================

.admission {
    animation: slideIn 1.2s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes slideIn {
    0% {
        transform: translateY(60px);
        opacity: 0;
    }

    100% {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes fadeUp {
    0% {
        opacity: 0;
        transform: translateY(15px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes floatGlow {

    0%,
    100% {
        transform: translate(0, 0) scale(1);
    }

    50% {
        transform: translate(20px, -20px) scale(1.1);
    }
}

@keyframes floatImg {

    0%,
    100% {
        transform: translateY(0) scale(1);
    }

    50% {
        transform: translateY(-10px) scale(1.02);
    }
}

@keyframes pulseDot {

    0%,
    100% {
        transform: scale(1);
        opacity: 0.6;
    }

    50% {
        transform: scale(1.6);
        opacity: 1;
    }
}

@keyframes barWave {

    0%,
    100% {
        transform: scaleY(1);
    }

    50% {
        transform: scaleY(1.8);
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

@keyframes rotateBorder {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

@keyframes pulseGlow {

    0%,
    100% {
        transform: scale(1);
        opacity: 0.5;
    }

    50% {
        transform: scale(1.1);
        opacity: 0.8;
    }
}

@keyframes shimmer {
    0% {
        background-position: -200% 0;
    }

    100% {
        background-position: 200% 0;
    }
}
</style>